import { useCallback, useEffect, useState } from 'react';
import OrganizationFacilitiesAndEmailsReportPage from '../../OrganizationFacilitiesAndEmailsReportPage';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { useOrganizationFacilitiesAndEmailsReport } from '../../hooks/useOrganizations';
import { getErrorMessage } from '../../utils/requestErrors';
import { getNextSortCriterion, type FieldSortCriterionValue } from '../../utils/tableSort';

export default function OrganizationFacilitiesAndEmailsReportContainer() {
  const { currentUser } = useLegacyAppSession();
  const hasAdminReports = Boolean(
    currentUser?.isSuperUser || currentUser?.internalRoleActions?.includes('ReadInternalReports')
  );
  const [sort, setSort] = useState<FieldSortCriterionValue>({
    fieldName: 'name',
    isAscending: true,
  });
  const { data, error } = useOrganizationFacilitiesAndEmailsReport({
    enabled: hasAdminReports,
    sortField: sort.fieldName,
    sortAscending: sort.isAscending,
  });

  useEffect(() => {
    if (error) {
      showToastError(getErrorMessage(error, 'Could not retrieve organizations'));
    }
  }, [error]);

  const onSort = useCallback((fieldName: string) => {
    setSort((current) => getNextSortCriterion(current, fieldName));
  }, []);

  return (
    <OrganizationFacilitiesAndEmailsReportPage
      hasAdminReports={hasAdminReports}
      organizations={data}
      sort={sort}
      onSort={onSort}
    />
  );
}
